import React from 'react';
import {
	ToothPathology,
	ToothRestorationFillingValues,
	ToothSurface,
} from '../../../../graphql/graphql';
import { ToothViewData } from '../Tooth/teethData';
import DENTToothSurface from '../Tooth/DENTToothSurface';
import useRestorationSurfaceOutline from '../../Hooks/Tooth/Restoration/useRestorationSurfaceOutline';

interface Props {
	toothViewData: ToothViewData;
	pathology: ToothPathology;
	surface: ToothSurface;
	values: ToothRestorationFillingValues;
}

const DENTToothRestorationFillingSurface = ({
	toothViewData,
	pathology,
	surface,
	values,
}: Props) => {
	const { baseColor, outlineProps } = useRestorationSurfaceOutline({
		quality: values.quality,
		material: values.material,
		surface,
		pathology,
	});

	return (
		<DENTToothSurface
			toothViewData={toothViewData}
			surface={surface}
			color={baseColor}
			outlineProps={outlineProps}
		/>
	);
};

export default DENTToothRestorationFillingSurface;
